export const IS_PROD = true;

export const ROLE_PATHS = {
  ADMIN: [
    "/dashboard",
    "/dashboard/admin/payments",
    "/dashboard/admin/users",
    "/dashboard/admin/plans",
  ],
  USER: ["/dashboard/plan", "/dashboard/profile"],
};

export const EXTRA_PATHS = {
  ADMIN: [],
  USER: ["/dashboard/accounts"],
};

export const FORM_URL = IS_PROD
  ? "https://forms.convisas.net/form-user.php"
  : "http://localhost:8000/form-user.php";

export const DOC_TYPES = ["CC", "CE", "PAS", "NIT", "TI"] as const;

export const VITE_STRIPE_PUBLIC_KEY = IS_PROD
  ? "pk_live_51SLriAFu4bFZCT5RFgX5Ooo7sP6KI27YeysITAX188IguViSOAsuErcEFcZNvhJcD8sVu6ZtDraO1cnMfUFItsDz00RrWlKkwE"
  : "pk_test_51SLriVFi7SJ5N5omBpGvnqtCy58aRN4ldy3NvH4qWfiGW0tr4ANMMphkNGUQio9zffDEU4Plzq0LRiTxafeDQYZv00336PuSLK";

export const drawerWidth = 260;

export const MAX_IMAGES = 5;
export const AMERICAS_COUNTRIES = [
  {
    code: "+54",
    label: "Argentina",
    iso: "ar",
    flag: "https://flagcdn.com/w20/ar.png",
  },
  {
    code: "+591",
    label: "Bolivia",
    iso: "bo",
    flag: "https://flagcdn.com/w20/bo.png",
  },
  {
    code: "+55",
    label: "Brasil",
    iso: "br",
    flag: "https://flagcdn.com/w20/br.png",
  },
  {
    code: "+1",
    label: "Canadá",
    iso: "ca",
    flag: "https://flagcdn.com/w20/ca.png",
  },
  {
    code: "+56",
    label: "Chile",
    iso: "cl",
    flag: "https://flagcdn.com/w20/cl.png",
  },
  {
    code: "+57",
    label: "Colombia",
    iso: "co",
    flag: "https://flagcdn.com/w20/co.png",
  },
  {
    code: "+506",
    label: "Costa Rica",
    iso: "cr",
    flag: "https://flagcdn.com/w20/cr.png",
  },
  {
    code: "+53",
    label: "Cuba",
    iso: "cu",
    flag: "https://flagcdn.com/w20/cu.png",
  },
  {
    code: "+593",
    label: "Ecuador",
    iso: "ec",
    flag: "https://flagcdn.com/w20/ec.png",
  },
  {
    code: "+503",
    label: "El Salvador",
    iso: "sv",
    flag: "https://flagcdn.com/w20/sv.png",
  },
  {
    code: "+594",
    label: "Guayana Francesa",
    iso: "gf",
    flag: "https://flagcdn.com/w20/gf.png",
  },
  {
    code: "+502",
    label: "Guatemala",
    iso: "gt",
    flag: "https://flagcdn.com/w20/gt.png",
  },
  {
    code: "+592",
    label: "Guyana",
    iso: "gy",
    flag: "https://flagcdn.com/w20/gy.png",
  },
  {
    code: "+504",
    label: "Honduras",
    iso: "hn",
    flag: "https://flagcdn.com/w20/hn.png",
  },
  {
    code: "+52",
    label: "México",
    iso: "mx",
    flag: "https://flagcdn.com/w20/mx.png",
  },
  {
    code: "+505",
    label: "Nicaragua",
    iso: "ni",
    flag: "https://flagcdn.com/w20/ni.png",
  },
  {
    code: "+507",
    label: "Panamá",
    iso: "pa",
    flag: "https://flagcdn.com/w20/pa.png",
  },
  {
    code: "+595",
    label: "Paraguay",
    iso: "py",
    flag: "https://flagcdn.com/w20/py.png",
  },
  {
    code: "+51",
    label: "Perú",
    iso: "pe",
    flag: "https://flagcdn.com/w20/pe.png",
  },
  {
    code: "+597",
    label: "Surinam",
    iso: "sr",
    flag: "https://flagcdn.com/w20/sr.png",
  },
  {
    code: "+598",
    label: "Uruguay",
    iso: "uy",
    flag: "https://flagcdn.com/w20/uy.png",
  },
  {
    code: "+58",
    label: "Venezuela",
    iso: "ve",
    flag: "https://flagcdn.com/w20/ve.png",
  },
  {
    code: "+1",
    label: "Estados Unidos",
    iso: "us",
    flag: "https://flagcdn.com/w20/us.png",
  },
];
